// removed by extract-text-webpack-plugin
module.exports = {"button":"G62fd94","buttonFullWidth":"Gd7daeb","buttonChild":"G3f6bf6"};